'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'What We Support', href: '#solutions' },
  { label: 'Reservations', href: '#contributions' },
  { label: 'FAQ', href: '#faq' },
];

export default function PublicNav() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-card/95 backdrop-blur border-b border-border">
      <div className="max-w-screen-xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link href="/" className="flex items-center gap-2.5">
          <AppLogo size={36} />
          <span className="font-extrabold text-xl text-foreground tracking-tight">
            BuildCredits
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks?.map((link) => (
            <Link
              key={`nav-${link?.label}`}
              href={link?.href}
              className="px-3.5 py-2 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150"
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link href="/sign-up-login-screen" className="btn-ghost text-sm">
            Log In
          </Link>
          <Link href="/build-my-solution" className="btn-primary text-sm">
            Request Support
          </Link>
        </div>

        <button
          className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle mobile menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden border-t border-border bg-card px-6 py-4 flex flex-col gap-2 animate-fade-in">
          {navLinks?.map((link) => (
            <Link
              key={`mobile-nav-${link?.label}`}
              href={link?.href}
              className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground hover:bg-muted transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              {link?.label}
            </Link>
          ))}
          <div className="pt-2 border-t border-border flex flex-col gap-2">
            <Link href="/sign-up-login-screen" className="btn-outline text-sm">
              Log In
            </Link>
            <Link href="/build-my-solution" className="btn-primary text-sm">
              Request Support
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
